import { apiService } from '../services/apiService';

export interface HotGame {
    "@context": string;
    "@id": string;
    "@type": string;
    id: number;
    title: string;
    date: string;
    time: string;
    timezone: string;
    sport: string;
    teams: string;
    why_hot: string;
    broadcast: string;
    city: string;
    country: string;
    zipcode: string;
}

export interface HotGamesResponse {
    member: HotGame[];
}

export const getHotGames = async (): Promise<HotGame[]> => {
    try {
        const response = await apiService.get<HotGamesResponse>('/common/game_master_ai_hot_games');
        return response.data.member;
    } catch (error) {
        console.error('Error fetching hot games:', error);
        return [];
    }
};